import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["lang"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ntfc_view = _resolveComponent("ntfc-view")!
  const _component_nft_ntfc_view = _resolveComponent("nft-ntfc-view")!
  const _component_alert_popup_view = _resolveComponent("alert-popup-view")!
  const _component_loading_view = _resolveComponent("loading-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app-inner",
    class: _normalizeClass(`theme-light theme-${_ctx.labelName} lang-${_ctx.locale}`),
    lang: _ctx.locale
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    _createVNode(_component_ntfc_view),
    _createVNode(_component_nft_ntfc_view),
    _createVNode(_component_alert_popup_view),
    (_ctx.appLoading)
      ? (_openBlock(), _createBlock(_component_loading_view, { key: 0 }))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "teleport" }, null, -1))
  ], 10, _hoisted_1))
}